<template>
  <!-- Add Employee Modal -->
  <div id="add_employee" class="modal custom-modal fade" role="dialog">
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Add Employee</h5>
          <button type="button" class="btn-close" ref="Close" data-bs-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <Form @submit="onSubmit" :validation-schema="schema" v-slot="{ errors }">
            <div class="row">
              <div class="col-sm-6">
                <div class="input-block mb-3">
                  <label class="col-form-label">First Name <span class="text-danger">*</span></label>
                  <Field class="form-control" name="first_name" placeholder="First Name" type="text"
                    :class="{ 'is-invalid': errors.first_name }" />
                  <div class="invalid-feedback">{{ errors.first_name }}</div>
                  <div class="emailshow text-danger" id="first_name"></div>
                </div>
              </div>
              <div class="col-sm-6">
                <div class="input-block mb-3">
                  <label class="col-form-label">Last Name <span class="text-danger">*</span></label>
                  <Field class="form-control" name="last_name" placeholder="Last Name" type="text"
                    :class="{ 'is-invalid': errors.last_name }" />
                  <div class="invalid-feedback">{{ errors.last_name }}</div>
                  <div class="emailshow text-danger" id="last_name"></div>
                </div>
              </div>
              <div class="col-sm-6">
                <div class="input-block mb-3">
                  <label class="col-form-label">Employee Code</label>
                  <Field class="form-control" name="employee_code" placeholder="Employee Code" type="text"
                    :class="{ 'is-invalid': errors.employee_code }" />
                  <div class="invalid-feedback">{{ errors.employee_code }}</div>
                  <div class="emailshow text-danger" id="employee_code"></div>
                </div>
              </div>
              <div class="col-sm-6">
                <div class="input-block mb-3">
                  <label class="col-form-label">Email</label>
                  <Field class="form-control" name="email" placeholder="Email" type="email" />
                </div>
              </div>
              <div class="col-sm-6">
                <div class="input-block position-relative mb-3">
                  <div class=" pass-group">
                    <label class="col-form-label">Password<span class="text-danger">*</span></label>
                    <Field class="form-control pass-input" name="password" :type="showPassword ? 'text' : 'password'"
                      placeholder="Password" :class="{ 'is-invalid': errors.password }" />
                    <span @click="toggleShow" class="toggle-password">
                      <i :class="{
                        'fas fa-eye': showPassword,
                        'fas fa-eye-slash': !showPassword,
                      }"></i>
                    </span>
                    <div class="invalid-feedback">{{ errors.password }}</div>
                    <div class="emailshow text-danger" id="password"></div>
                  </div>
                </div>
              </div>

              <div class="col-sm-6">
                <div class="input-block mb-3">
                  <label class="col-form-label">Joining Date</label>
                  <div class="cal-icon">
                    <!-- <Input class="form-control" value="sdsfs" type="date" /> -->
                    <date-picker placeholder="Choose Date" class="form-control datetimepicker" :editable="true"
                      :clearable="false" name="joining_date" :model-value="joining_date" @update:model-value="onJoiningDateChange" :inputFormat="dateFormat" />
                  </div>
                </div>
              </div>
              <div class="col-sm-6">
                <div class="input-block mb-3">
                  <label class="col-form-label">Probation Ending Date </label>
                  <div class="cal-icon">
                    <date-picker placeholder="Choose Date" class="form-control datetimepicker" :editable="true"
                      :clearable="false" name="probation_ends_at" v-model="probation_ends_at" />
                  </div>
                </div>
              </div>
              <div class="col-sm-6">
                <div class="input-block mb-3">
                  <label class="col-form-label">Salary Amount<span class="text-danger">*</span></label>
                  <Field type="text" class="form-control" name="salary_amount" placeholder="Salary Amount"
                    :class="{ 'is-invalid': errors.salary_amount }" />
                  <div class="invalid-feedback">{{ errors.salary_amount }}</div>
                  <div class="emailshow text-danger" id="salary_amount"></div>
                </div>
              </div>
              <div class="col-sm-6">
                <div class="input-block mb-3">
                  <label class="col-form-label">Profile Image</label>
                  <Field class="form-control" type="file" accept="image/x-png,image/jpeg" name="profile_image_path"
                    placeholder="Profile Image" />
                </div>
              </div>
              <div class="col-sm-6">
                <div class="input-block mb-3">
                  <label class="col-form-label">Salary Period<span class="text-danger">*</span></label>
                  <Field type="text" class="form-control disabled" name="salary_period" v-model="salary_period"
                    style="display:none;"></Field>
                  <vue-select v-model="salary_period" :options="salaryPeriod" placeholder="Salary Period"
                    id="salary_period" name="salary_period" :class="{ 'is-invalid': errors.salary_period }"
                    @select="mySelectEvent($event, 'salary_period')" />
                  <div class="invalid-feedback">{{ errors.salary_period }}</div>
                  <div class="emailshow text-danger" id="salary_period"></div>

                </div>
              </div>
              <div class="col-sm-6">
                <div class="input-block d-flex align-items-center gap-3 mb-3">
                  <label class="custom_check lh-base mb-0">Enabled Geo Fence<span class="text-danger">*</span> :</label>
                  <Field type="checkbox" v-model="is_geo_fence_enabled" :value=1 :unchecked-value=0
                    name="is_geo_fence_enabled"/>
                 
                </div>
              </div>
              <div class="col-sm-6">
                <div class="input-block d-flex align-items-center gap-3 mb-3 ">
                  <label class="custom_check lh-base mb-0">Enabled Auto Checkout<span class="text-danger">*</span>
                    :</label>
                  <Field type="checkbox" v-model="is_auto_checkout_enabled" :value=1
                    :unchecked-value=0 name="is_auto_checkout_enabled"/>
                  
                </div>
              </div>
              <div class="col-sm-6">
                <div class="input-block mb-3">
                  <label class="col-form-label">Yearly Leave Count</label>
                  <Field type="text" class="form-control" v-model="yearly_leave_count" name="yearly_leave_count"
                    placeholder="Yearly Leave Count" />
                </div>
              </div>
              <div class="col-sm-6">
                <div class="input-block mb-3">
                  <label class="col-form-label">Probation Leave Count</label>
                  <Field type="text" class="form-control" v-model="probation_leave_count" name="probation_leave_count"
                    placeholder="Probation Leave Count" />
                </div>
              </div>
              <div class="col-md-6">
                <div class="input-block mb-3">
                  <label class="col-form-label">Role<span class="text-danger">*</span></label>
                  <Field type="text" class="form-control disabled" name="company_role_id" v-model="company_role_id"
                    style="display:none;"></Field>
                  <vue-select v-model="company_role_id" :options="companyId" placeholder="Select Role"
                    name="company_role_id" id="company_role_id" @select="mySelectEvent($event, 'company_role_id')"
                    :class="{ 'is-invalid': errors.company_role_id }" />
                  <div class="invalid-feedback">{{ errors.company_role_id }}</div>
                  <div class="emailshow text-danger" id="company_role_id"></div>
                </div>
              </div>
              <!-- <div class="col-md-6">
                <div class="input-block mb-3">
                  <label class="col-form-label">Role<span class="text-danger">*</span></label>
                  <Field type="text" class="form-control disabled" name="company_role_id" v-model="company_role_id"
                    style="display:none;"></Field>
                  <vue-select v-model="company_role_id" :options="companyId" placeholder="Select Role"
                    name="company_role_id" id="company_role_id" @select="mySelectEvent($event, 'company_role_id')"
                    :class="{ 'is-invalid': errors.company_role_id }" />
                  <div class="invalid-feedback">{{ errors.company_role_id }}</div>
                  <div class="emailshow text-danger" id="company_role_id"></div>
                </div>
              </div> -->
              <div class="col-md-6">
                <div class="input-block mb-3">
                  <label class="col-form-label">Account Type<span class="text-danger">*</span></label>
                  <Field type="text" class="form-control disabled" name="userType" v-model="userType"
                    style="display:none;"></Field>
                  <vue-select v-model="userType" :options="account_types" placeholder="Select Type"
                    name="userType" id="userType" @select="mySelectEvent($event, 'userType')"
                    :class="{ 'is-invalid': errors.userType }" />
                  <div class="invalid-feedback">{{ errors.userType }}</div>
                  <div class="emailshow text-danger" id="userType"></div>
                </div>
              </div>
              <div class="col-md-6" v-if="userType === 'Member'">
                <div class="input-block mb-3">
                  <label class="col-form-label">Manager<span class="text-danger">*</span></label>
                  <Field type="text" class="form-control disabled" name="managerSelected" v-model="managerSelected"
                    style="display:none;"></Field>
                  <vue-select v-model="managerSelected" :options="manager_ids" placeholder="Select Manager"
                    name="managerSelected" id="managerSelected" @select="mySelectEvent($event, 'managerSelected')"
                    :class="{ 'is-invalid': errors.managerSelected }" />
                  <div class="invalid-feedback">{{ errors.managerSelected }}</div>
                  <div class="emailshow text-danger" id="managerSelected"></div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="input-block mb-3">
                  <label class="col-form-label">Location Ids<span class="text-danger">*</span></label>
                  <vue-select :settings="{ multiple: true }" :options="locationId" name="location_ids"
                    placeholder="Select Location" id="location_ids" @select="mySelectEvent($event, 'location_ids')"
                    :class="{ 'is-invalid': errors.location_ids }" />
                  <div class="invalid-feedback">{{ errors.location_ids }}</div>
                  <div class="emailshow text-danger" id="location_ids"></div>
                </div>
              </div>
              <div class="col-md-6" v-if="userInfo.is_admin === 1">
                <div class="input-block mb-3">
                  <label class="col-form-label">Permissions</label>
                  <vue-select :options="permissionsOption" name="permissions"
                    placeholder="Select Permissions" id="permissions" @select="mySelectEvent($event, 'permissions')"
                    />
      
                </div>
              </div>

            </div>

            <div class="submit-section">
              <button class="btn btn-primary submit-btn" type="submit">
                <span v-if="!loader">Submit</span>
                <div class="spinner-border spinner-border-sm text-light" role="status" v-else>
                  <span class="visually-hidden">Loading...</span>
                </div>
              </button>
            </div>
          </Form>
        </div>
      </div>
    </div>
  </div>
  <!-- /Add Employee Modal -->

  <!-- Delete Employee Modal -->
  <div class="modal custom-modal fade" id="delete_employee" role="dialog">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-body">
          <div class="form-header">
            <h3>Delete Employee</h3>
            <p>Are you sure want to delete?</p>
          </div>
          <div class="modal-btn delete-action">
            <div class="row">
              <div class="col-6">
                <a href="javascript:void(0);" class="btn btn-primary continue-btn">Delete</a>
              </div>
              <div class="col-6">
                <a href="javascript:void(0);" data-bs-dismiss="modal" class="btn btn-primary cancel-btn">Cancel</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Delete Employee Modal -->
</template>

<script>
import { ref } from "vue";
import { Form, Field } from "vee-validate";
import axios from "axios";
import {VUE_APP_API_BASE_URL} from "../../config";
import * as Yup from "yup";
import dayjs from "dayjs";
const currentDate = ref(new Date());
export default {
  components: {
    Form, Field
  },

  data() {
    return {
      showPassword: false,
      select2: null,
      loader: false,
      startdate: currentDate,
      selected: null,
      companyId: null,
      locationId: null,
      first_name: "",
      last_name: "",
      employee_code: "",
      email: "",
      password: "",
      joining_date: new Date(),
      profile_image_path: "",
      salary_amount: "",
      salary_period: null,
      is_geo_fence_enabled: null,
      is_site_admin:0,
      is_admin:0,
      is_auto_checkout_enabled: null,
      probation_ends_at: dayjs().add(3, 'month').toDate(),
      yearly_leave_count: "",
      probation_leave_count: "",
      company_role_id: null,
      managerSelected: null,
      location_ids: [],
      manager_ids: null,
      deactivated_at: "",
      dateFormat: 'dd/MM/yyyy',
      salaryPeriod: ["hourly", "weekly", "monthly", "yearly"],
      account_types: ["Member", "Manager", "Site Manager"],
      userType: null,
      permissionsOption:["None", "Admin"],
      userInfo: JSON.parse(localStorage.getItem("userInfo"))
    };
  },
  mounted() {
    this.getCompanyRoles(),
    this.getLocationIds(),
    this.getManagers()
  },
  methods: {
    toggleShow() {
      this.showPassword = !this.showPassword;
    },

    onJoiningDateChange(value) {
      this.joining_date = value;
      if (value && dayjs(value).isValid()) {
        this.probation_ends_at = dayjs(value).add(3, 'month').toDate();
      } else {
        this.probation_ends_at = null;
      }
    },

    mySelectEvent(event, input) {
      switch (input) {
        case 'salary_period':
          this.salary_period = event.id;
          break;
        case 'company_role_id':
          this.company_role_id = event.id;
          break;
        case 'userType':
          break;  
        case 'managerSelected':
          this.managerSelected = event.id;
          break;  
        case 'location_ids':
          if (event.selected === true) {

            this.location_ids.push(event.id);
          } else {
            var index = this.location_ids.indexOf(event.id);
            if (index !== -1) {
              this.location_ids.splice(index, 1);

            }
          }
          break;
        case 'permissions':
          if(event.text === "Admin"){
            this.is_admin = 1;
          }
          if(event.text === "None") {
            this.is_admin = 0;
          }
          
          break;  
        default:
          break;
      }
    },

    // uploadImage(e){
    //             const image = e.target.files[0];
    //             const reader = new FileReader();
    //             reader.readAsDataURL(image);
    //             reader.onload = e =>{
    //                 this.profile_image_path = e.target.result;
    //                 console.log(this.profile_image_path);
    //             };
    //         },

    async onSubmit(values) {
      this.loader = true;
      const formData = new FormData();
      formData.append("first_name", values.first_name);
      formData.append("last_name", values.last_name);
      formData.append("employee_code", values.employee_code || "");
      formData.append("email", values.email);
      formData.append("password", values.password);
      if (this.joining_date && dayjs(this.joining_date).isValid()) {
        formData.append("joining_date", dayjs(this.joining_date).format("YYYY-MM-DD HH:mm:ss"));
      }
      if (values.profile_image_path) {
        formData.append("profile_image_path", values.profile_image_path);
      }
      formData.append("salary_amount", values.salary_amount);
      formData.append("salary_period", this.salary_period);
      formData.append("is_geo_fence_enabled", this.is_geo_fence_enabled);
      formData.append("is_auto_checkout_enabled", this.is_auto_checkout_enabled);
      formData.append("is_admin", this.is_admin);
      formData.append("is_site_admin", this.is_site_admin);
      formData.append("yearly_leave_count", values.yearly_leave_count);
      if (this.probation_ends_at && dayjs(this.probation_ends_at).isValid()) {
        formData.append("probation_ends_at", dayjs(this.probation_ends_at).format("YYYY-MM-DD HH:mm:ss"));
      }
      formData.append("probation_leave_count", values.probation_leave_count);
      formData.append("company_role_id", this.company_role_id);
      
      formData.append("account_type", this.userType);
      if(this.userType === 'Member'){
         formData.append("manager_id", this.managerSelected);
      }
     
      this.location_ids.forEach((element, i) => {
        formData.append(`location_ids[${i}]`, element);
      });

      await axios.post(`${VUE_APP_API_BASE_URL}/user/add`, formData)
        .then((response) => {
          if (response.data.status === true) {
            this.$toast.success(response.data.message);
            this.$emit("userAdded");
            this.loader = false;
            this.first_name = "";
            this.last_name = "";
            this.employee_code = "";
            this.email = "";
            this.joining_date = new Date();
            this.probation_ends_at = dayjs(this.joining_date).add(3, 'month').toDate();
            this.yearly_leave_count = "";
            this.probation_leave_count = "";
            this.company_role_id = null;
            this.salary_amount = "";
            this.salary_period = null;
            this.is_geo_fence_enabled = null;
            this.is_auto_checkout_enabled = null;
            this.userType = null;
            this.managerSelected = null;
            this.location_ids = [];
            this.is_site_admin=0;
            this.is_admin=0;
            this.$refs.Close.click();
          } else {
            this.$toast.error(response.data.message || response.data.errors);
            this.loader = false;
            // this.errorMessage = response.data.message ?? "";
          }
        }).catch(function (error) {
          console.log(error);
          this.loader = false;
        });
    },

    async getCompanyRoles() {
      await axios.get(`${VUE_APP_API_BASE_URL}/company-role/get`)
        .then((response) => {
          if (response.data.status) {
            this.companyId = response.data.data
            this.companyId.forEach(element => {
              delete element['created_at'];
              delete element['updated_at'];
              element['text'] = element['name'];
              delete element['name'];
            });
          } else {
            this.errorMessage = response.data.message ?? "";
          }
        }).catch(function (error) {
          console.log(error);
        });
    },

    async getLocationIds() {
      await axios.get(`${VUE_APP_API_BASE_URL}/location/all`)
        .then((response) => {
          if (response.data.status) {
            this.locationId = response.data.data
            this.locationId.forEach(element => {
              delete element['created_at'];
              delete element['updated_at'];
              delete element['latitude'];
              delete element['longitude'];
              element['text'] = element['name'];
              delete element['name'];
            })
          } else {
            this.errorMessage = response.data.message ?? "";
          }
        }).catch(function (error) {
          console.log(error);
        })
        .finally(() => {

        });
    },

      async getManagers() {
      await axios.get(`${VUE_APP_API_BASE_URL}/user/manager-list`)
        .then((response) => {
          if (response.data.status) {
            this.manager_ids = response.data.data;
            this.manager_ids.forEach(element => {
             
              element['text'] = element['first_name'] + ' ' +element['last_name'];
              delete element['first_name'];
              delete element['last_name'];

            })
          } else {
            this.errorMessage = response.data.message ?? "";
          }
        }).catch(function (error) {
          console.log(error);
        })
        .finally(() => {

        });
    },



  },



  setup() {
    const schema = Yup.object().shape({
      first_name: Yup.string().required("First Name is required"),
      last_name: Yup.string().required("last Name is required"),
      // employee_code: Yup.string().required("Employee Code is required"),
      password: Yup.string().min(6, "Password must be at least 6 characters")
        .required("Password is required"),
      salary_amount: Yup.string().required("Salary Amount is required"),
      salary_period: Yup.string().required("Salary Period is required"),
      company_role_id: Yup.string().required("Role is required"),
      userType: Yup.string().required("Role is required"),
      });
      
    return {
      schema,
    };
  },
}
</script>

<style scoped>
.pass-input.is-invalid+.toggle-password {
  bottom: 0;
}

.toggle-password {
  top: 49px !important;
  right: 28px;
  position: absolute;
}
</style>